import { TruckType } from 'src/app/registration/shared/models/truck-type.model';

export class DrivingExperience {
  id: string;
  noTruckingExperience: boolean;
  truckTypes?: TruckType[];

  constructor(data?: DrivingExperience) {
    if (data) {
      this.id = data.id || null;
      this.noTruckingExperience = data.noTruckingExperience;
      this.truckTypes = data.truckTypes || [];
    }
  }
}